import Head from "next/head";
import { ImgSrc } from "@config/image";
import { Config } from "@configured/EnvironmentConfig";

type BlogMetaDataProps = {
  description: string;
  title: string;
  author: string;
  image: string;
  slug: string;
};

const BlogMetaData = ({
  description,
  title,
  author,
  image,
  slug,
}: BlogMetaDataProps) => {
  const url = `${Config.siteURL}/blog/${slug}`;
  const imageUrl = `${Config.siteURL}${ImgSrc(image)}`;

  return (
    <Head>
      <meta name="description" content={description} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Blues Developer Hub" />
      <meta
        property="article:publisher"
        content="https://www.facebook.com/buildwithblues/"
      />
      <meta property="og:image" content={imageUrl} />
      <meta property="author" content={author} />
    </Head>
  );
};

export default BlogMetaData;
